// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6c3032{margin-top:var(--medium-spacer);position:sticky;bottom:0;padding:var(--medium-spacer) var(--spacer);margin:0 calc(-1*var(--spacer)) calc(-1*var(--medium-spacer));background:linear-gradient(rgba(255, 255, 255, 0), var(--background) 40%)}[aria-roledescription=modal] ._6c3032{padding:var(--medium-spacer);margin:0 calc(-1*var(--medium-spacer)) calc(-1*var(--medium-spacer));bottom:calc(-1*var(--medium-spacer))}[aria-roledescription=modal] ._6c3032:empty{padding-top:0}", ""]);
// Exports
exports.locals = {
	"footer": "_6c3032"
};
module.exports = exports;
